export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),

  onInit(data) {
    this.formValues.age = data?.formValues?.age || this.store.values.age
  },
})
